import { ErrorHandler, Injectable, Injector  } from "@angular/core";
import { Router } from "@angular/router";
import { HttpErrorResponse } from '@angular/common/http';
// import { GlobalObservables } from "../../../app.global.observer";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // globalObs;

  // constructor(globalObs: GlobalObservables) {
  //  this.globalObs = globalObs;
  // }


  handleError(error: any): void {

  //  console.log('handleError');
  //  console.log(error);
  //  throw error;
  //  ////log errors in debug console
  //  //if (error.status === 500 || error.status === 502) {
  //  //  this.globalObs.pushError.next({
  //  //    status: error.status,
  //  //    message: error.statusText,
  //  //    url: error.url,
  //  //    date: new Date
  //  //  });
  //  //}
  }
}
